// extracted by mini-css-extract-plugin
module.exports = {"alternativeGroup":"style-module_alternativeGroup__iQoWRjZRHVVeuXmc3XTK"};